import React, {useEffect, useState} from 'react';
import Api from '../../../../interface/api/visit';
import {Pagination} from "../../../../component/paging";
import {Page} from "../../../../interface/model/page";
import {Search1} from "../../../../component/search";

import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import {dateConvert} from "../index";
import {convertDate} from "../../../../util/convertDate";

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: '1px solid #e1e1e1',
        },
    },
});

function getDefaultSearchInfo() {
    const today = convertDate(new Date());
    return {
        searchToDate : today,
        searchFromDate : today,
        visitorInfoSearchType : 'visitorName',
        searchValue : ''
    };
}

export default function Unreturned() {
    const classes = useRowStyles();
    const [open, setOpen] = React.useState({
        index : 0,
        flag : false,
        visitorHistoryInfos : []
    });
    const [visitorList, setVisitorList] = useState<Page>();
    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ searchInfo , setSearchInfo ] = useState(getDefaultSearchInfo)

    function pageMoveHandler(pageNumber) {
        Api.getUnreturnedVisitorListBySearchAndPage(searchInfo, pageNumber).then(res => setVisitorList(res.data));
    }

    function searchHandler() {
        Api.getUnreturnedVisitorListBySearchAndPage(searchInfo, pageNumber).then(res => setVisitorList(res.data));
    }

    useEffect(() => {
        Api.getUnreturnedVisitorListBySearchAndPage(getDefaultSearchInfo(), 0).then(res =>
            setVisitorList(res.data)
        );
    }, [])

    return (
        <>
            <div className="add">
                <Search1 searchHandler={searchHandler} searchInfo={searchInfo} setSearchInfo={setSearchInfo}/>
                <div className="nv_table_box adminVersion">
                    <TableContainer component={Paper}>
                        <table className={"nv_table"} aria-label="a dense table">
                            <thead>
                            <tr>
                                <th align="center">방문자</th>
                                <th align="center" className="m_skip">업체명</th>
                                <th align="center" className="m_skip">연락처</th>
                                <th align="center" className="m_skip">차량번호</th>
                                <th align="center" className="m_skip">방문증번호</th>
                                <th align="center">입문일시</th>
                                <th align="center" className="m_skip">퇴문일시</th>
                                <th align="center" className="m_skip">방문목적</th>
                                <th align="center" className="m_skip">방문위치</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                visitorList!==undefined && visitorList.content.length > 0 ?
                                    visitorList.content.map((visitor, index) => (
                                        <>
                                            <tr className={classes.root}>
                                                <td align="center">{visitor.name}</td>
                                                <td align="center" className="m_skip">{visitor.company}</td>
                                                <td align="center" className="m_skip">{visitor.phone}</td>
                                                <td align="center" className="m_skip">{visitor.car}</td>
                                                <td align="center" className="m_skip">{visitor.card}</td>
                                                <td align="center">{`${dateConvert(visitor.checkInTime)}`}</td>
                                                <td align="center" className="m_skip">
                                                    {visitor.checkOutTime!=null ? `${dateConvert(visitor.checkOutTime)}` : `-`}
                                                </td>
                                                <td align="center" className="m_skip">{visitor.visitPurpose}</td>
                                                <td align="center" className="m_skip">{visitor.visitLocation}</td>
                                            </tr>
                                        </>
                                    )) :
                                    <tr>
                                        <td colSpan={10} align="center">등록된 방문 이력이 없습니다.</td>
                                    </tr>
                            }
                            </tbody>
                        </table>
                    </TableContainer>
                    <Pagination page={visitorList} pageMoveHandler={pageMoveHandler} />
                </div>
            </div>
        </>
    )
}
